<template>
  <div class="graduate-apply-record">
    <a-table
      :columns="columns"
      :data-source="data"
      :loading="loading"
      rowKey="id"
    >
    </a-table>
  </div>
</template>

<script>
export default {
  name: "graduateApplyRecord",
  data: function () {
    return {
      loading: false,
      data: [],
      columns: [
        { title: '学生姓名', dataIndex: 'stuName', width: 120 },
        { title: '学号', dataIndex: 'stuNo', width: 120 },
        { title: '专业', dataIndex: 'proName', width: 120 },
        { title: '提交时间', dataIndex: 'applyTime', width: 150 },
        { title: '审核状态', dataIndex: 'finalStatus_dictText', width: 120},
      ],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      this.axios.get(`/degree/stuDegree/stuGraInfo?type=record`).then((res) => {
        this.loading = false;
        if (res && res.code === 200) {
          // 确保 data 是一个数组
          if (Array.isArray(res.result)) {
            this.data = res.result;
          } else if (res.result) {
            // 如果是对象，将其包装为数组
            this.data = [res.result];
          } else {
            // 如果没有结果，设置为空数组
            this.data = [];
          }
        } else {
          this.data = [];
        }
      }).catch((error) => {
        this.loading = false;
        console.error('获取申请记录失败:', error);
        this.$message.error('获取申请记录失败，请稍后重试');
        this.data = [];
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';

.graduate-apply-record {
  background: #fff;
  padding: 28px;
  margin-top: 20px;
  
  :deep(.ant-table) {
    .success {
      color: #52c41a;
    }
    .error {
      color: #ff4d4f;
    }
    .processing {
      color: #1890ff;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/PersonalCenters/components/graduateApplyTabs/record.vue